export default {"src":"/_next/static/media/Frame_14414.daeeb9a2.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};